import { Routes, Route } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Home from "./pages/Home";
import ServicioDetalle from "./pages/ServicioDetalle";
import SumateAlEquipo from "./pages/Sumatealequipo";
import Header from "./components/Header";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Header />
      <main style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servicios/:id" element={<ServicioDetalle />} />
          <Route path="/sumatealequipo" element={<SumateAlEquipo />} />
        </Routes>
      </main>
      <a
        href="https://wa.me/5491153175146" 
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img src="/images/WhatsApp.png" alt="WhatsApp" />
      </a>

      <Footer />
    </>
  );
}

export default App;
